import React from "react";
import { User, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

export type EmptyStateProps = {
  searchText: string;
  onCreateNew?: () => void;
};

const EmptyState = ({ searchText, onCreateNew }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center py-12 text-center">
    <div className="rounded-full bg-muted p-6 mb-4">
      <User className="h-12 w-12 text-muted-foreground opacity-50" />
    </div>
    <h3 className="text-lg font-semibold mb-2">No customers found</h3>
    <p className="text-sm text-muted-foreground mb-6 max-w-sm">
      No customers match &ldquo;{searchText}&rdquo;. Try adjusting your search
      or create a new customer.
    </p>
    {onCreateNew && (
      <Button onClick={onCreateNew} variant="outline" className="gap-2">
        <UserPlus className="h-4 w-4" />
        Create New Customer
      </Button>
    )}
  </div>
);

export default React.memo(EmptyState);
